import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { B as Button } from './button.js';
import { S as StyledHost } from './styled-host.js';
import './details.js';
import { c as checkPkgVersion, J as JustifiAnalytics } from './check-pkg-version.js';
import './utils2.js';
import { C as ComponentErrorSeverity, a as ComponentErrorCodes } from './ComponentError.js';
import './Checkout.js';
import './Pagination.js';
import './Payment.js';
import './Refund.js';
import './Document.js';
import { d as defineCustomElement$i } from './bank-account-form2.js';
import { d as defineCustomElement$h } from './card-form2.js';
import { d as defineCustomElement$g } from './custom-popper2.js';
import { d as defineCustomElement$f } from './form-control-checkbox2.js';
import { d as defineCustomElement$e } from './form-control-help-text2.js';
import { d as defineCustomElement$d } from './form-control-radio2.js';
import { d as defineCustomElement$c } from './form-control-select2.js';
import { d as defineCustomElement$b } from './form-control-text2.js';
import { d as defineCustomElement$a } from './form-control-tooltip2.js';
import { d as defineCustomElement$9 } from './hidden-input2.js';
import { d as defineCustomElement$8 } from './iframe-input2.js';
import { d as defineCustomElement$7 } from './billing-form.js';
import { d as defineCustomElement$6 } from './new-payment-method.js';
import { d as defineCustomElement$5 } from './payment-method-options.js';
import { d as defineCustomElement$4 } from './save-new-payment-method.js';
import { d as defineCustomElement$3 } from './saved-payment-method.js';
import { d as defineCustomElement$2 } from './sezzle-payment-method.js';

const TokenizePaymentMethod = /*@__PURE__*/ proxyCustomElement(class TokenizePaymentMethod extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.errorEvent = createEvent(this, "error-event", 7);
        this.submitEvent = createEvent(this, "submit-event", 7);
        this.submitButtonText = 'Submit';
        this.iframeOrigin = "https://components.justifi.ai";
        this.isLoading = false;
    }
    componentWillLoad() {
        checkPkgVersion();
        this.analytics = new JustifiAnalytics(this);
    }
    async tokenizePaymentMethod(event) {
        event && event.preventDefault();
        this.isLoading = true;
        let tokenizeResponse;
        try {
            tokenizeResponse = await this.paymentMethodOptionsRef.resolvePaymentMethod({ isValid: true });
            if (tokenizeResponse.error) {
                this.errorEvent.emit({
                    errorCode: tokenizeResponse.error.code,
                    message: tokenizeResponse.error.message,
                    severity: ComponentErrorSeverity.ERROR,
                });
            }
        }
        catch (error) {
            const errorData = {
                errorCode: ComponentErrorCodes.TOKENIZE_ERROR,
                message: error.message,
                severity: ComponentErrorSeverity.ERROR,
            };
            this.errorEvent.emit(errorData);
        }
        finally {
            this.submitEvent.emit({ response: tokenizeResponse });
            this.isLoading = false;
            return tokenizeResponse;
        }
    }
    async fillBillingForm(fields) {
        this.paymentMethodOptionsRef.fillBillingForm(fields);
    }
    async validate() {
        const { isValid } = await this.paymentMethodOptionsRef.validate();
        return { isValid };
    }
    render() {
        return (h(StyledHost, { key: 'f78888ef0c0564df455a7e61990e718b6e827700' }, h("form", { key: '318c2496c73203c7e2c714ba03335118e6bb7136' }, h("fieldset", { key: '3b8e53e611480c2fe43be940162d2f2bc517ea69' }, h("div", { key: 'd8903132e22f7d79842ae22165aea45be0e263fd', class: "row gy-3" }, h("div", { key: '57e4b60b4acd33665a36384e4f6d1cd941f5eaeb', class: "col-12" }, h("justifi-payment-method-options", { key: '48b35447ccc01f8592354cf5c5e53ce8a53db880', ref: (el) => (this.paymentMethodOptionsRef = el), "show-card": !this.disableCreditCard, "show-ach": !this.disableBankAccount, "show-bnpl": false, paymentMethodGroupId: this.paymentMethodGroupId, "show-saved-payment-methods": false, hideCardBillingForm: this.hideCardBillingForm, hideBankAccountBillingForm: this.hideBankAccountBillingForm, authToken: this.authToken, "account-id": this.accountId, iframeOrigin: this.iframeOrigin })), h("div", { key: '6bd68d95bf5a4d090f00f8a6415d38c0b202ee3a', class: "col-12" }, h(Button, { key: 'cd61787511188bc099d625f6ef44301e5603a495', variant: "primary", type: "submit", onClick: event => this.tokenizePaymentMethod(event), isLoading: this.isLoading, "data-testid": "submit-button", hidden: this.hideSubmitButton }, this.submitButtonText)))))));
    }
}, [1, "justifi-tokenize-payment-method", {
        "authToken": [1, "auth-token"],
        "accountId": [1, "account-id"],
        "paymentMethodGroupId": [1, "payment-method-group-id"],
        "submitButtonText": [1, "submit-button-text"],
        "disableCreditCard": [4, "disable-credit-card"],
        "disableBankAccount": [4, "disable-bank-account"],
        "hideSubmitButton": [4, "hide-submit-button"],
        "hideCardBillingForm": [4, "hide-card-billing-form"],
        "hideBankAccountBillingForm": [4, "hide-bank-account-billing-form"],
        "iframeOrigin": [1, "iframe-origin"],
        "isLoading": [32],
        "tokenizePaymentMethod": [64],
        "fillBillingForm": [64],
        "validate": [64]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-tokenize-payment-method", "bank-account-form", "card-form", "custom-popper", "form-control-checkbox", "form-control-help-text", "form-control-radio", "form-control-select", "form-control-text", "form-control-tooltip", "hidden-input", "iframe-input", "justifi-billing-form", "justifi-new-payment-method", "justifi-payment-method-options", "justifi-save-new-payment-method", "justifi-saved-payment-method", "justifi-sezzle-payment-method"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-tokenize-payment-method":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, TokenizePaymentMethod);
            }
            break;
        case "bank-account-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "card-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "form-control-radio":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "hidden-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "iframe-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "justifi-billing-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "justifi-new-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "justifi-payment-method-options":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "justifi-save-new-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "justifi-saved-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "justifi-sezzle-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const JustifiTokenizePaymentMethod = TokenizePaymentMethod;
const defineCustomElement = defineCustomElement$1;

export { JustifiTokenizePaymentMethod, defineCustomElement };
